import { render, staticRenderFns } from "./AddProviderClassificationInfo.vue?vue&type=template&id=0f24a4f4"
import script from "./AddProviderClassificationInfo.vue?vue&type=script&lang=js"
export * from "./AddProviderClassificationInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports